import React, { FC, memo, PropsWithChildren } from 'react';
import { ScrollBarProps } from 'react-perfect-scrollbar';
import { PerfectScrollbarStyled } from './styles';
import { FnPerfectScrollbarVariants } from './constants';

interface Props extends ScrollBarProps {
  styled?: boolean;
  variant?: FnPerfectScrollbarVariants;
}
// TODO Add opportunity to configure size of scroll
const FnPerfectScrollbar: FC<PropsWithChildren<Props>> = ({
  styled = false,
  variant = FnPerfectScrollbarVariants.Primary,
  children,
  ...props
}) => (
  <PerfectScrollbarStyled styled={Number(styled)} variant={variant} {...props}>
    {children}
  </PerfectScrollbarStyled>
);

export default memo(FnPerfectScrollbar);
